import pack from '../../package.json';
import cartModule from '../cartModule.js';

cartModule.controller('VersionCtrl', ['$scope', ($scope) => {
    console.log('Package', pack);

    $scope.package = pack;
}]);
